export default function HowToEarn() {
  const steps = [
    {
      icon: "ri-user-add-line",
      color: "text-amber-400",
      bg: "bg-amber-400/10",
      border: "border-amber-400/20",
      title: "سجّل حساباً",
      desc: "أنشئ حسابك مجاناً بجوالك وابدأ رحلة المكافآت",
    },
    {
      icon: "ri-shopping-cart-2-line",
      color: "text-green-400",
      bg: "bg-green-400/10",
      border: "border-green-400/20",
      title: "اطلب منتجاتك",
      desc: "كل طلب تستلمه يمنحك نقاطاً — نقطة لكل 10 ر.س",
    },
    {
      icon: "ri-truck-line",
      color: "text-cyan-400",
      bg: "bg-cyan-400/10",
      border: "border-cyan-400/20",
      title: "استلم طلبك",
      desc: "تُضاف النقاط تلقائياً فور تأكيد استلام الطلب",
    },
    {
      icon: "ri-gift-2-line",
      color: "text-rose-400",
      bg: "bg-rose-400/10",
      border: "border-rose-400/20",
      title: "استمتع بالمزايا",
      desc: "ارقَ في المستويات واحصل على خصومات وهدايا حصرية",
    },
  ];

  return (
    <div className="bg-[#111] border border-white/8 rounded-3xl p-6">
      <h2 className="text-white text-base font-black mb-5 flex items-center gap-2" style={{ fontFamily: "'Cairo', sans-serif" }}>
        <i className="ri-route-line text-amber-400"></i>
        كيف تكسب النقاط؟
      </h2>

      <div className="relative">
        {/* Connector line */}
        <div className="absolute top-8 right-8 w-0.5 h-[calc(100%-4rem)] bg-gradient-to-b from-amber-400/30 to-transparent hidden sm:block"></div>

        <div className="flex flex-col gap-4">
          {steps.map((step, idx) => (
            <div key={idx} className="flex items-start gap-4">
              <div className={`relative w-16 h-16 flex items-center justify-center ${step.bg} border ${step.border} rounded-2xl flex-shrink-0 z-10`}>
                <i className={`${step.icon} ${step.color} text-2xl`}></i>
                <div className={`absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center bg-[#111] border ${step.border} rounded-full`}>
                  <span className={`text-[10px] font-black ${step.color}`} style={{ fontFamily: "'Cairo', sans-serif" }}>
                    {idx + 1}
                  </span>
                </div>
              </div>
              <div className="flex-1 pt-1">
                <p className="text-white text-sm font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>{step.title}</p>
                <p className="text-gray-500 text-xs mt-1 leading-relaxed" style={{ fontFamily: "'Cairo', sans-serif" }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Points formula */}
      <div className="mt-5 bg-[#1a1a1a] rounded-2xl p-4 border border-white/5">
        <p className="text-gray-400 text-xs mb-3 font-bold" style={{ fontFamily: "'Cairo', sans-serif" }}>معادلة النقاط</p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <div className="flex flex-col items-center gap-1">
            <div className="bg-amber-400/10 border border-amber-400/20 rounded-xl px-4 py-2">
              <p className="text-amber-400 text-lg font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>10 ر.س</p>
            </div>
            <p className="text-gray-600 text-[10px]" style={{ fontFamily: "'Cairo', sans-serif" }}>إنفاق</p>
          </div>
          <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
          <div className="flex flex-col items-center gap-1">
            <div className="bg-green-400/10 border border-green-400/20 rounded-xl px-4 py-2">
              <p className="text-green-400 text-lg font-black" style={{ fontFamily: "'Cairo', sans-serif" }}>1 نقطة</p>
            </div>
            <p className="text-gray-600 text-[10px]" style={{ fontFamily: "'Cairo', sans-serif" }}>مكافأة</p>
          </div>
        </div>
      </div>
    </div>
  );
}
